'use strict';

var React = require('react');

var SvgFolderUpMajor = function SvgFolderUpMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 17.5v-13a1.5 1.5 0 0 0-1.5-1.5h-6.879c-.397 0-.779-.158-1.06-.44l-1.121-1.121a1.503 1.503 0 0 0-1.061-.439h-4.879a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5zm-8-7.085 1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3a.997.997 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414l1.293-1.293v3.586a1 1 0 1 0 2 0v-3.586z"
  }));
};

exports.SvgFolderUpMajor = SvgFolderUpMajor;
